import { useCallback, useEffect, useRef, useState } from "react";
import { getBranchApplicationsAPI } from "../../../utils/api/applications";
import { errorMessage } from "./applicationsText";

// Loads one branch's view of every supported application (the shared store
// account plus the branch's own data and requests). Reloads whenever the shared
// workflow reports a change (`revision`), so the Branches page, the Applications
// page and their modals always show the same backend data. Only the latest
// branch/store answer is kept.
export default function useBranchApplications({ token, storeId, branchId, revision, enabled, t }) {
  const [state, setState] = useState({ status: "idle", data: null, error: "" });
  const latest = useRef("");

  const load = useCallback(
    async (silent = false) => {
      if (!enabled || !token || !storeId || !branchId) return;
      const key = `${storeId}/${branchId}`;
      latest.current = key;
      if (!silent) setState({ status: "loading", data: null, error: "" });
      try {
        const res = await getBranchApplicationsAPI(token, storeId, branchId);
        if (latest.current === key) setState({ status: "ready", data: res.data, error: "" });
      } catch (e) {
        if (latest.current === key) setState((current) => ({ status: "error", data: silent ? current.data : null, error: errorMessage(t, e) }));
      }
    },
    [enabled, token, storeId, branchId, t],
  );

  // Fresh load when the branch changes; silent reload after workflow changes.
  useEffect(() => {
    load(false);
  }, [load]);
  const first = useRef(true);
  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    load(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [revision]);

  return { ...state, reload: () => load(false) };
}
